import { DateRow, DisplayIdRow, DownloadLink, PriceRow, TextRow, UnitsRow, ApptFlags, SimpleTooltip, ApptDetailRow } from 'components';
import React from 'react';
import { Images, PermissionList, previewFile, RolePermission } from 'utils';
import { PENDING_CLAIM } from '../constants';
import { ApptStateInfo } from '../../../../schedule/core/modals/apptDetail/apptStateInfo';
import { Checkbox } from '@mui/material';

export const claimPaymentTableHead = (from) => [
    { name: 'id', title: 'ID', custom: false, noSearch: true, width: '100px' },
    from === 'remittance' && { name: '', title: 'Payment ID', custom: false, noSearch: true, width: '100px' },
    { name: '', title: 'User name', custom: false, noSearch: true },
    { name: '', title: 'Created Date', custom: false, noSearch: true, width: '120px' },
    { name: '', title: 'Voided Date', custom: false, noSearch: true, width: '120px' },
    { name: '', title: 'Allowed AMT', custom: false, noSearch: true },
    { name: '', title: 'Deductible', custom: false, noSearch: true },
    { name: '', title: 'Coinsurance', custom: false, noSearch: true },
    { name: '', title: 'Copay', custom: false, noSearch: true },
    { name: '', title: 'Paid Amt', custom: false, noSearch: true },
    { name: '', title: 'Status', custom: false, noSearch: true },
];

export const claimPaymentTableBody = (from) => [
    { rowText: (item) => <DisplayIdRow id={item?.displayId ? item?.displayId : item?.id} /> },
    from === 'remittance' && { rowText: (item) => <DisplayIdRow id={item?.remittanceDisplayId ? item?.remittanceDisplayId : ''} /> },
    {
        rowText: (item) => <TextRow name={item?.creator?.firstName ? `${item?.creator?.firstName} ${item?.creator?.lastName}` : '--'} />,
    },
    { rowText: (item) => <DateRow date={item?.createdDate} /> },
    { rowText: (item) => <DateRow date={item?.voidedDate} /> },
    { rowText: (item) => <PriceRow info={item?.allowedAMT} /> },
    { rowText: (item) => <PriceRow info={item?.deductible} /> },
    { rowText: (item) => <PriceRow info={item?.coIns} /> },
    { rowText: (item) => <PriceRow info={item?.copay} /> },
    { rowText: (item) => <PriceRow info={item?.paidAMT} /> },
    {
        rowText: (item) => (
            <p className={item?.status === 'ACTIVE' ? 'active-status' : 'inactive-status'}>
                {item?.status === 'ACTIVE' ? 'Active' : 'Voided'}
            </p>
        ),
    },
];

export const billApptHead = (claimDetails, from, handleSelect, fullList, selected) => [
    claimDetails?.status !== PENDING_CLAIM &&
        RolePermission([PermissionList.REMOVE_CLAIM_APPT?.code]) &&
        from !== 'invoice' && {
            renderView: (
                <SimpleTooltip title={<p>Select All</p>} placement="top-start">
                    <Checkbox
                        onClick={(e) => handleSelect(e, '', 'all')}
                        name={'checkBox'}
                        style={{ padding: 0, color: '#0C66E4' }}
                        checked={fullList?.length === selected?.length}
                    />
                </SimpleTooltip>
            ),
            width: '30px',
        },
    { name: '', title: 'ID', custom: false, noSearch: true },
    { name: '', title: 'DOS', custom: false, noSearch: true },
    { name: '', title: 'Units', custom: false, noSearch: true },
    { name: '', title: 'Signature', custom: false, noSearch: true },
    claimDetails?.status !== PENDING_CLAIM &&
        RolePermission([PermissionList.REMOVE_CLAIM_APPT?.code]) &&
        from !== 'invoice' && { name: '', title: ' ', custom: false, noSearch: true, width: '100px' },
];

export const billApptBody = (tableStyle, claimDetails, afterSuccess, from, close, handleSelect, fullList, selected) => [
    // RolePermission([PermissionList.REMOVE_CLAIM_APPT?.code]) && from !== 'invoice' &&
    claimDetails?.status !== PENDING_CLAIM &&
        RolePermission([PermissionList.REMOVE_CLAIM_APPT?.code]) &&
        from !== 'invoice' && {
            button: (handle, item) => {
                return (
                    <Checkbox
                        disabled={item?.removedFromClaimFlag}
                        onClick={(e) => handleSelect(e, item)}
                        name={'checkBox'}
                        style={{ padding: 0, color: '#0C66E4', opacity: item?.removedFromClaimFlag ? 0.5 : 1 }}
                        checked={selected?.includes(item?.id)}
                    />
                );
            },
            notClickable: true,
        },
    {
        rowText: (item) => (
            <div className={'flex-align-center'} style={{ gap: 8 }}>
                <div onClick={close}>
                    <ApptDetailRow name={item?.displayId ? item.displayId : '--'} id={item?.id} afterSuccess={afterSuccess} />
                </div>
                {!!item?.issues?.length && <ApptStateInfo appt={item} />}
            </div>
        ),
        notClickable: true,
    },
    { rowText: (item) => <DateRow date={item?.dos || item?.startTime} /> },
    { rowText: (item) => <UnitsRow info={item?.units} /> },
    {
        rowText: (item) => (
            <div>
                {item?.signature?.key ? (
                    <div className={tableStyle.linksWrapper}>
                        <div className={tableStyle.linksButtonWrapper}>
                            <a role="button" style={{ cursor: 'pointer' }} onClick={() => previewFile(item?.signature)}>
                                <p>View</p>
                                <img src={Images.showEye} alt="view" />
                            </a>
                        </div>
                        <div className={tableStyle.linksButtonWrapper}>
                            <DownloadLink linkInnerText={'Download'} file={item?.signature} small={true} />
                        </div>
                    </div>
                ) : (
                    '--'
                )}
            </div>
        ),
    },
    RolePermission([PermissionList.REMOVE_CLAIM_APPT?.code]) &&
        from !== 'invoice' && {
            rowText: (item) => {
                return (
                    <div>
                        {item?.removedFromClaimFlag && (
                            <SimpleTooltip title={<p>{'Appointment was removed from claim'}</p>} placement="bottom" arrow>
                                <p style={{ color: '#E90715' }}>Removed</p>
                            </SimpleTooltip>
                        )}
                    </div>
                );
            },
        },
];

export const billInfoList = (billById) => {
    return [
        { title: 'DOS:', value: <DateRow date={billById?.dos} /> },
        { title: 'CPT Code:', value: billById?.cptCode },
        { title: 'Modifier:', value: [billById?.chargeRateModifier, billById?.chargeRateModifier2, billById?.chargeRateModifier3].filter(Boolean).join(', ') || undefined },
        { title: 'Units:', value: <UnitsRow info={billById?.totalUnits} /> },
    ];
};

export const billDetailsList = (billById) => {
    return [
        {
            title: 'Diagnostic Pointers',
            value: billById?.diagnosticPointer?.length ? <TextRow name={billById?.diagnosticPointer?.map((i) => i).join(', ')} /> : '--',
        },
        { title: 'Payer Total', value: <PriceRow info={billById?.payorTotal} /> },
        {
            title: 'Place of Service',
            value: (
                <TextRow
                    name={`${billById?.placeOfService} ${billById?.placeOfServiceCode ? `${billById?.placeOfServiceCode}:` : ''} ${
                        billById?.posModifier ? `(${billById?.posModifier})` : '--'
                    }`}
                />
            ),
        },
        { title: 'Payer Paid', value: <PriceRow info={billById?.payorPaid} /> },
        { title: 'Total Billed', value: <PriceRow info={billById?.totalBilled} /> },
        { title: 'Payer Balance', value: <PriceRow info={billById?.payorBalance} /> },
        { title: 'Allowed', value: <PriceRow info={billById?.allowedAMT} /> },
        { title: 'Client Total', value: <PriceRow info={billById?.clientTotal} /> },
        {
            title: 'Rendering Provider NPI Number',
            value: <TextRow name={billById?.renderingProvider ? billById?.renderingProvider : '--'} />,
        },
        { title: 'Client Paid', value: <PriceRow info={billById?.clientPaid} /> },
        { title: '', value: ' ', background: 'white' },
        { title: 'Client Balance', value: <PriceRow info={billById?.clientBalance} /> },
    ];
};
